const ACTION_TYPE = {
    ADD_DEFAULT_VIDEOS: "ADD_DEFAULT_VIDEOS",
    CATEGORIES: "CATEGORIES",
    TIME: "TIME",
    SORT_WAY: "SORT_WAY",
    CLEAR_ALL: "CLEAR_ALL",
    ADD_WATCH_LATER: "ADD_WATCH_LATER",
    ADD_LIKES: "ADD_LIKES",
    ADD_HISTORY: "ADD_HISTORY",
    ADD_PLAYLIST: "ADD_PLAYLIST",
    ADD_SINGLE_PLAYLIST: "ADD_SINGLE_PLAYLIST",
    SINGLE_VIDEO: "SINGLE_VIDEO",
    USER_LOGOUT: "USER_LOGOUT",
    SEARCH_TEXT: "SEARCH_TEXT",
    SEARCH_VIDEOS: "SEARCH_VIDEOS",
    ACTIVATE_ALERT: "ACTIVATE_ALERT",
    DEACTIVATE_ALERT: "DEACTIVATE_ALERT",
};

export { ACTION_TYPE };
